import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { fetchClusters, deleteCluster, showUpdateClusterForm } from '../actions/clusters.js'

import { connect } from 'react-redux'
import { fetchCompanies } from '../actions/companies.js'
import { fetchBuildings } from '../actions/buildings.js'
import { Card, CardText } from 'material-ui/Card'
import { Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn } from 'material-ui/Table'
import { default as FlatButton } from 'material-ui/FlatButton'
import { default as RaisedButton } from 'material-ui/RaisedButton'
import { default as CircularProgress } from 'material-ui/CircularProgress'
import { default as ConfirmButton } from 'material-ui-confirm-button'
import { default as Delete } from 'material-ui/svg-icons/action/delete'
import { default as Edit } from 'material-ui/svg-icons/image/edit'

import AddCluster from '../components/clusters/AddCluster'

const style = {
  marginBottom: 10
}

const iconStyle = {
  margin: 0,
  padding: 0,
  minWidth: 0,
  width: 50
}

export class Clusters extends Component {
  static defaultProps = { clustersFetched: false }

  static propTypes = {
    dispatch: PropTypes.func.isRequired
  }

  componentDidMount() {
    const { dispatch } = this.props
    dispatch(fetchClusters())
    dispatch(fetchBuildings())
    document.title = 'Clusters - Admin - Better Spaces'
  }

  deleteCluster(cluster) {
    const { dispatch } = this.props
    dispatch(deleteCluster(cluster))
  }

  showAddClustersForm() {
    const { dispatch } = this.props
    dispatch(showUpdateClusterForm({buildings:[]}))
  }

  updateCluster(cluster) {
    const { dispatch } = this.props
    dispatch(showUpdateClusterForm(cluster))
  }

  render() {
    if (this.props.clustersFetched) {
      if (this.props.clusters && this.props.buildings && this.props.clusters.length > 0 ) {
        this.props.clusters.sort(function(a, b) {
          if (a.name < b.name) return -1
          if (a.name > b.name) return 1
          return 0
        })

        return (
          <div>
            <AddCluster />
            {this.props.role.length > 6 && this.props.role.charAt(6) == '2' ? (
              <RaisedButton label='Add Cluster' primary={true} style={style} onClick={this.showAddClustersForm.bind(this)} />
            ) : (
              <div />
            )}
            <Table selectable={false} style={{ tableLayout: 'auto' }} fixedHeader={false}>
              <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
                <TableRow>
                  <TableHeaderColumn style={{ width: '3%' }}>ID</TableHeaderColumn>
                  <TableHeaderColumn style={{ width: '30%' }}>Name</TableHeaderColumn>

                  <TableHeaderColumn style={{ width: '15%' }} />
                </TableRow>
              </TableHeader>
              <TableBody displayRowCheckbox={false}>
                {this.props.clusters.map((cluster, index) => (
                  <TableRow>
                    <TableRowColumn style={{ wordWrap: 'break-word', whiteSpace: 'normal', width: '3%' }}>{index + 1}</TableRowColumn>
                    <TableRowColumn style={{ wordWrap: 'break-word', whiteSpace: 'normal', width: '30%' }}>{cluster.name}</TableRowColumn>

                    {this.props.role.length > 6 && this.props.role.charAt(6) == '2' ? (
                      <TableRowColumn style={{ wordWrap: 'break-word', whiteSpace: 'normal', width: '15%' }}>
                        <FlatButton icon={<Edit />} style={iconStyle} primary={true} onClick={this.updateCluster.bind(this, cluster)} />
                        <ConfirmButton
                          key={cluster._id}
                          isFlat={true}
                          style={iconStyle}
                          icon={<Delete />}
                          confirmMessage='	&#10004;'
                          cancelMessage='X'
                          secondary={true}
                          onSubmit={this.deleteCluster.bind(this, cluster)}
                        />
                      </TableRowColumn>
                    ) : (
                      <TableRowColumn />
                    )}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </div>
        )
      } else {
        return (
          <div>
          <AddCluster />
          {this.props.role.length > 6 && this.props.role.charAt(6) == '2' ? (
            <RaisedButton label='Add Cluster' primary={true} style={style} onClick={this.showAddClustersForm.bind(this)} />
          ) : (
            <div />
          )}
          <Card style={{ width: '100%', height: '100%' }}>
            <CardText style={{ position: 'relative', width: '100%', height: '100%' }}>No Clusters</CardText>
          </Card>
          </div>
        )
      }
    } else {
      return (
        <Card style={{ width: '100%', height: '100%' }}>
          <CardText style={{ position: 'relative', width: '100%', height: '100%' }}>
            <CircularProgress size={80} thickness={5} style={{ marginLeft: '50%' }} />
          </CardText>
        </Card>
      )
    }
  }
}

const mapStateToProps = (state) => {
  const { isFetching } = state.clustersReducer

  if (isFetching) {
    return {
      isFetching
    }
  } else {
    return {
      ...state.clustersReducer,
      role: state.usersReducer.role
    }
  }
}

export default connect(mapStateToProps)(Clusters)



// WEBPACK FOOTER //
// ./src/containers/Clusters.js